import { registerArchetype } from './index.js';
import { getRuntimes } from '../combat.js';
registerArchetype({
    id: 'damage_reflect',
    apply: ({ state, source, params }) => {
        const amount = params.amount ?? 0.2;
        const r = getRuntimes(state, source.side)[source.slot];
        r.statuses.push({
            id: `damage_reflect_${source.slot}`,
            kind: 'buff',
            remainingTicks: Number.MAX_SAFE_INTEGER,
            params: { reflectPct: amount }
        });
    }
});
